import translations from './translations';
import type { I18nConfig } from '../interfaces/II18nConfig';

interface ITranslationsItems {
  [key: string]: string;
}

interface ITranslations {
  [key: string]: ITranslationsItems;
}

export class I18n {
  protected static defaultLang: string = 'ru';
  protected currentLang: string;
  protected fallbackLang: string;
  protected translations: ITranslations = translations;
  protected overrides: ITranslations;

  constructor(config: I18nConfig) {
    this.currentLang = config.lang || I18n.defaultLang;
    this.fallbackLang = config.fallbackLang || I18n.defaultLang;
    this.overrides = config.translations ?? {};
  }

  public getLocale(): ITranslationsItems {
    const builtInFallback =
      this.translations[this.fallbackLang] ?? this.translations[I18n.defaultLang] ?? {};
    const customFallback = this.overrides[this.fallbackLang] ?? {};
    const builtInCurrent = this.translations[this.currentLang] ?? {};
    const customCurrent = this.overrides[this.currentLang] ?? {};

    return {
      ...builtInFallback,
      ...customFallback,
      ...builtInCurrent,
      ...customCurrent,
    };
  }
}
